import { isCustomRoleKey, roleBadgeColor, roleDisplayName, roleLabel, tt } from '@agos/shared'
import { StatusBadge } from '@agos/ui'

import type { RoleView } from '../roles/roles-api'
import { roleColor } from '../employees/staff-roster'

/**
 * A role as one badge - its name in its colour, the same on a card, in a list of people, in the trail and in the
 * delegation sentences (§9.752).
 *
 * **The colour is the role's own when it has one of the ten**, and the built-in palette *Zamestnanci* has always drawn
 * otherwise (`roleColor`), so a built-in role looks the same on both screens. A custom role says what it works as in
 * its title, because the base is what the code decides by (§10A.407) and a name alone hides it.
 */
export function RoleChip({
  roleKey,
  roles,
  size = 'sm',
}: {
  roleKey: string
  roles: readonly RoleView[]
  size?: 'sm' | 'md'
}) {
  const role = roles.find((candidate) => candidate.key === roleKey)
  const base = role?.baseRole ?? (isCustomRoleKey(roleKey) ? '' : roleKey)
  const name = role === undefined ? roleLabel(roleKey) : roleDisplayName(role)
  const title =
    role !== undefined && !role.builtIn && base !== ''
      ? `${tt('Pracuje ako')}: ${roleLabel(base)}`
      : undefined
  return (
    <span data-role-chip={roleKey} className="inline-flex">
      <StatusBadge
        label={name}
        color={roleBadgeColor(role?.color, roleColor(base))}
        size={size}
        title={title}
      />
    </span>
  )
}
